import * as types from "./mutation-types";
import { SnackbarProgrammatic as Snackbar } from "buefy";

const actions = {
  setIsMobile({ commit }, isMobile) {
    commit(types.SET_IS_MOBILE, isMobile);
  },

  /**
   * https://buefy.org/documentation/snackbar/
   *
   * type: `is-white`, `is-black`, `is-light`,
   *       `is-dark`, `is-primary`, `is-info`,
   *       `is-success`, `is-warning`, `is-danger`
   * message,
   * position: `is-top`, `is-bottom`, `is-bottom-right`
   *           `is-top-right`
   * duration:   in miliseconds (default is 3500)
   * queue:      will queue with other notices if any
   * indefinite:  show until dismissed
   * actionText: button text
   * onAction:   callback fn to be called on button click
   */
  snackBar(_, data) {
    // destructure data and set default if property was not found in data
    const {
      type = "is-success",
      position = "is-top",
      duration = 10000,
      queue = false,
      message = "There might have been an error. Please contact wellness@be-engaged.co",
      actionText = "OK",
      onAction = () => {},
      indefinite = false
    } = data;

    Snackbar.open({
      type,
      position,
      duration,
      queue,
      message,
      actionText,
      onAction,
      indefinite
    });
  }
};

export default actions;
